import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import upvIcon from '../resources/UPV-Emblem.png'
import EmpresaEstandarIcon from '../resources/led_test_center.png'
import BscIcon from '../resources/bsc.jpg'

function Trajectory() {
	return(
		<div id="TrajectoryContainer">
			<h2>ESTUDIOS Y EXPERIENCIA</h2>
			<VerticalTimeline>
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
					contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
					date="2014 - 2019"
					iconStyle={{
						background: 'rgb(33, 150, 243)',
						color: '#fff',
						backgroundImage: `url(${upvIcon})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					  }}
				>
					<h3 className="vertical-timeline-element-title"> Ingenieria de Telecomunicaciones, sonido e imagen</h3>
					<h4 className="vertical-timeline-element-subtitle">Universitat politèctica de València, Campus de Gandia</h4>
					<p>
					Especialización en la rama de telecomunicaciones. TFG enfocado a la medición de parámetros ambientales en la agricutura con IOT
					</p>
				</VerticalTimelineElement>
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					date="2019 - 2019"

					iconStyle={{
						background: 'rgb(33, 150, 243)',
						color: '#fff',
						backgroundImage: `url(${upvIcon})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					  }}
				>
					<h3 className="vertical-timeline-element-title">Ingeniero en Telecomunicaciones</h3>
					<h4 className="vertical-timeline-element-subtitle">EPSG</h4>
					<p>
					Realización de mediciones de muestras médicas mediante el uso de una nariz electrónica desarrollada en la EPSG
					</p>
  				</VerticalTimelineElement>
				  <VerticalTimelineElement
					className="vertical-timeline-element--work"
					contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
					contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
					date="2019 - 2022"
					iconStyle={{
						background: 'rgb(33, 150, 243)',
						color: '#fff',
						backgroundImage: `url(${EmpresaEstandarIcon})`,
						backgroundSize: '80%',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center'
					  }}
				>
					<h3 className="vertical-timeline-element-title">Ingeniero en Telecomunicaciones</h3>
					<h4 className="vertical-timeline-element-subtitle">Led test center</h4>
					<p>
					Desarrollo de un dispositio IOT multifuncional para la parametrización y gestión de cultivos automatizados.
					</p>
				</VerticalTimelineElement>
				<VerticalTimelineElement
					className="vertical-timeline-element--work"
					date="2022 - actualidad"
					iconStyle={{
						background: 'rgb(33, 150, 243)',
						color: '#fff',
						backgroundImage: `url(${BscIcon})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					  }}
				>
					<h3 className="vertical-timeline-element-title">Ingeniero en Telecomunicaciones</h3>
					<h4 className="vertical-timeline-element-subtitle">BSC Solutions</h4>
					<p>
					Desarrollo de un registro distribuido y descentralizado enfocado al custodio certificado, control de trazabilidad y verificación de autenticidad de activos primarios fuera del mundo digital
					</p>
  				</VerticalTimelineElement>
			</VerticalTimeline>
		</div>
	)
}
export default Trajectory;